import { AuthProvider } from '@sdk/authentication/AuthContext';
import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { PersonaCollection as PersonaCollectionType } from '@sdk/personaCollection/types/PersonaCollection';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import { NotificationModal } from '@web/dashboard/NotificationModal/NotificationModal';
import { useAngularModalState } from '@web/common/hooks/useAngularModalState';
import { DashboardNotification } from '@web/dashboard/types/DashboardNotification';
import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  notification: DashboardNotification;
  Authentication: {
    user: AuthUserType;
  };
  PersonaCollection: PersonaCollectionType;
};

export const NotificationModalAngular = ({
  isOpen,
  onClose,
  notification,
  Authentication,
  PersonaCollection,
}: Props) => {
  const modalState = useAngularModalState(isOpen, onClose, {
    noDismiss: true,
    hideBackdrop: true,
    hideClose: true,
  });

  return (
    <AuthProvider currentUser={Authentication.user}>
      <UserSettingsProvider settings={Authentication.user.settings}>
        <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
          <PersonaCollectionContext.Provider value={PersonaCollection}>
            <QueryClientProvider>
              <NotificationModal
                modalState={modalState}
                notification={notification}
                onClose={onClose}
              />

              <ToastComponent />
            </QueryClientProvider>
          </PersonaCollectionContext.Provider>
        </UserOrgSettingsProvider>
      </UserSettingsProvider>
    </AuthProvider>
  );
};
